import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MoLoadingBar extends Vue {
  @Prop({ default: 0 })
  public progress: number
}
